<!-- SOURCE https://codepen.io/rachelnabors/pen/rxpmJL/ -->
<template>
  <div class="StreetView">
    <div class="streetview-container">
      <gmap-street-view-panorama class="pano" v-bind:pano="pano" v-bind:pov="formatPovObj" v-bind:zoom="zoom"
        @pano_changed="updatePano" @pov_changed="updatePov">
      </gmap-street-view-panorama>
      <div class="street-view-coordinates">
        <p><b>Pano ID</b> {{pano}}</p>
        <p><b>Heading</b> {{heading}}</p>
        <p><b>Pitch</b> {{pitch}}</p>
        <!-- <p><b>POV</b> {{pov}}</p> -->
      </div>
    </div>
  </div>
  </div>
</template>

<script>

  export default {
    name: 'StreetView',

    data() {
      return {
        pov: {},
      }
    },

    props: {
      pano: String,
      heading: Number,
      pitch: Number,
      zoom: Number,
      imageUrl: String
    },

    mounted() {
    },

    computed: {
      formatPovObj: function () {
        return {
          heading: parseFloat(this.heading), pitch: parseFloat(this.pitch), zoom: 2
        }
      }
    },
    methods: {
      formatPov: function () {
        // TODO - reset original POV
        return {
          heading: parseFloat(this.heading), pitch: parseFloat(this.pitch), zoom: 2
        }
      },

      updatePov(pov) {
        this.pov = pov;
        this.heading = pov.heading;
        this.pitch = pov.pitch;
      },

      updatePano(pano) {
        this.pano = pano;
      }
    }
  }
</script>

<style scoped>
  .streetview-container {
    width: 100%;
    height: auto;
  }

  .pano {
    width: 600px;
    height: 450px;
  }

  .street-view-coordinates {
    padding: 2rem 1rem 0rem 0.5rem;
    /* margin: 10px; */
    background-color: black;
    color: white;
    font-size: 12px;
  }

  .street-view-coordinates p {
    margin-top: -1rem;
  }
</style>